module.exports = __webpack_public_path__ + "static/media/port-containers.557730fd.jpg";